import type { Dispatch } from 'redux';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { Component } from '../../../common/model/types.tsx';
import {
	deleteComponentFailure,
	deleteComponentSuccess,
	patchComponent,
} from '../../../state/actions.tsx';
import { get as getAnalyticsData } from '../../../state/analytics/selectors.tsx';
import { getComponent } from '../../../state/components/selectors.tsx';
import { getLocale } from '../../../state/context/selectors.tsx';
import { getProjectKey } from '../../../state/project/selectors.tsx';
import type { State } from '../../../state/reducer.tsx';
import { getIssuesUrl } from '../../../state/selectors.tsx';
import {
	deleteComponentCancel,
	deleteComponentDialogDisplayed,
} from '../../../state/ui/delete/actions.tsx';
import View, { type Props } from './view.tsx';

type OwnProps = {
	id: string;
};

type StateProps = Pick<
	Props,
	'component' | 'projectKey' | 'locale' | 'analyticsData' | 'relatedIssueUrl'
>;

const mapStateToProps = (state: State, { id }: OwnProps): StateProps => ({
	component: getComponent(state, id),
	projectKey: getProjectKey(state),
	locale: getLocale(state),
	analyticsData: getAnalyticsData(state),
	relatedIssueUrl: getIssuesUrl(state, id),
});

type DispatchProps = Pick<
	Props,
	| 'onPatchComponentIssueCount'
	| 'onDeleteComponentSuccessful'
	| 'onDeleteComponentFailure'
	| 'onDeleteDialogDisplay'
	| 'onDeleteDialogCancel'
>;

const mapDispatchToProps = (dispatch: Dispatch, { id }: OwnProps): DispatchProps => ({
	onPatchComponentIssueCount: (issueCount: number) => {
		dispatch(patchComponent({ id, component: { issueCount } }));
	},
	onDeleteComponentSuccessful: (component: Component) => {
		dispatch(deleteComponentSuccess({ id, component }));
	},
	onDeleteComponentFailure: (error: FetchError, isDialogOpen: boolean) => {
		dispatch(deleteComponentFailure({ id, error, isDialogOpen }));
	},
	onDeleteDialogDisplay: () => {
		dispatch(deleteComponentDialogDisplayed({ id }));
	},
	onDeleteDialogCancel: () => {
		dispatch(deleteComponentCancel({ id }));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
